<template>
  <div class="teams-promo-wrapper">
    <button
      @click.stop.prevent="open()"
      data-testid="invite-team-members-btn"
      class="teams-promo-button"
      :class="{ 'teams-promo-button-disabled': isAtUserLimit }"
    >
      <Icon name="general.plus" size="base" />
      Invite team members
    </button>
  </div>
</template>

<script lang="ts" setup>
import { computed, onMounted } from 'vue';
import { storeToRefs } from 'pinia';
import { useModal } from '@/storybook/modal/useModal';
import InviteModal from '../InviteModal.vue';
import Icon from '@/storybook/icon/Icon.vue';
import { useEntitlements } from '@/composables/useEntitlements';
import { useOrganizationStore } from '@/store/useOrganizationStore';
import './sidebar.css';

const { open } = useModal(InviteModal);
const { limit, fetchEntitlements } = useEntitlements();
const orgStore = useOrganizationStore();
const { seatsCount, seatsLeft } = storeToRefs(orgStore);

// Fetch entitlements on mount to ensure limits are loaded
onMounted(() => {
  fetchEntitlements();
});

const userLimit = limit('users');

const isAtUserLimit = computed(() => {
  const limitVal = userLimit.value;
  if (!limitVal) {
    return false;
  }
  const seatsUsed = seatsCount.value - seatsLeft.value;
  return seatsUsed >= limitVal;
});
</script>

<style scoped>
.teams-promo-button-disabled {
  @apply opacity-50 cursor-pointer;
}
</style>
